






























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class TypeSelect extends Vue {
  @Prop({ default: 'myna' }) private value!: string
  @Prop({ default: false }) private readonly!: boolean
  @Prop({ default: '' }) private error!: string

  private get localSelected() {
    return this.value || ''
  }

  private set localSelected(v: string) {
    this.$emit('input', v)
  }
}
